export * from "./LeaguesConfiguration"